module.exports = __webpack_public_path__ + "static/decorated-plants-7b5345df8dda2adbb771a2a0f3ca7b29.jpg";